import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Button, Row, Col } from 'antd';
import Truncate from 'react-truncate-html';
import getEnv from '../../../../../../services/util/getEnv';

const { Paragraph } = Typography;
/*
const extractContent = (s) => {
  const span = document.createElement('span');
  span.innerHTML = s;
  return span.textContent || span.innerText;
};
*/
const JobCardInfo = (props) => {
  return (
    <Row className="job-card-info">
      <Col><Paragraph ellipsis className="job-card-title">{props.jobTitle}</Paragraph></Col>
      {props.showSeniority ? <Col style={{ marginTop: '8px' }}><Paragraph className="job-card-seniority">{props.seniority}</Paragraph></Col> : null}
      <Col className="job-card-description-col">
        <Paragraph className="job-card-description" ellipsis={{ rows: 4, expandable: false }}>
          {/* USING extractContent WILL MAKE THE TEXT ONE-LINER. IT SHOULD RETAINS FORMAT */}
          <Truncate lines={5}
            dangerouslySetInnerHTML={{
              __html: props.description
            }}
          />
        </Paragraph>
      </Col>
      <Col style={{ position: 'absolute', bottom: '10px' }} span={20} >
        <Row type="flex" justify="space-between" >
          <Col><Button type="link" className="job-card-button" onClick={() => props.onReadMore(props.jobId)}>Read more</Button></Col>
          {props.showMatchingLink ? <Col><a href={`${getEnv("REACT_APP_MATCHING_URL")}/job/${props.jobId}`} target="_blank" rel="noreferrer">View on Matching</a></Col> : null}
        </Row>
      </Col>
    </Row>
  );
};

JobCardInfo.propTypes = {
  jobTitle: PropTypes.string,
  seniority: PropTypes.string,
  onReadMore: PropTypes.func,
  jobId: PropTypes.number,
  description: PropTypes.string,
  showSeniority: PropTypes.bool,
  showMatchingLink: PropTypes.bool
};

export default React.memo(JobCardInfo);
